<template>
  <div class="menuDome">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeIndex"
        v-for="(item, i) in list"
        :key="i"
        router
        unique-opened
        :default-openeds="defaultOpendsList"
        class="el-menu-vertical-demo">
        <el-menu-item :index="item.url" v-if="!item.children||item.children.length === 0">
          <i v-if="item.className" :class="item.className" />
          <icon-svg v-else-if="item.icon" :icon-class="item.icon" />
          <img class="img" v-else :src="item.img" />
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>

        <el-submenu :index="item.url" v-else>
          <template slot="title">
            <i v-if="item.className" :class="item.className" />
            <icon-svg v-else-if="item.icon" :icon-class="item.icon" />
            <img class="img" v-else :src="item.img" />
            <span slot="title">{{ item.name }}</span>
          </template>
          <!-- 二级菜单 -->
          <el-menu-item-group v-for="(itemChildren, index) in item.children" :key="index">
            <el-menu-item :index="itemChildren.commonUrl" :route="{path: itemChildren.url}">{{ itemChildren.name }}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { getTwolevelAuthrity } from "@/common/js/storage";
export default {
  props: {
    menuList: {
      type: Array,
    },
    /* 1：一级管理员；2：二级管理员；4：财务管理员 */
    isLevelAdmin: {
      type: Number,
    }
  },
  data() {
    return {
      list: [],
      authorityList: [],
      defaultOpendsList: [],
      activeIndex: ''
    }
  },

  watch: {
    $route(to, form) {
      this.activeIndex = this.setCurrentRoute()
    }
  },
  created() {
    this.activeIndex = this.setCurrentRoute()
    this.authorityList = getTwolevelAuthrity()
    if (this.isLevelAdmin == 2) this.reconstruction()
  },
  mounted() {
    this.list = this.menuList
    if (this.list.length == 0) {
      this.$router.push({
        path: '/fire/noAuthority'
      })
    } else {
      let isSetCurrentRoute = []
      isSetCurrentRoute = this.treeFilter(this.list, node => node.commonUrl == this.activeIndex)
      if (isSetCurrentRoute.length == 0) {
        this.$router.push({
          path: this.list[0].children[0].url
        })
      }
    }
    this.activeIndex = this.setCurrentRoute()
  },

  methods: {
    /* 树结构筛选 */
    treeFilter(tree, func) {
      // 使用map复制一下节点，避免修改到原树
      return tree.map(node => ({ ...node })).filter(node => {
        node.children = node.children && this.treeFilter(node.children, func)
        return func(node) || (node.children && node.children.length)
      })
    },
    setCurrentRoute() {
      let path = this.$router.history.current.path.split('/')
      let url = `/${path[1]}/${path[2]}`
      let thirdUrl = url+`/${path[3]}`
      let arr = [
        '/oneLevel/systemIndex',
        '/oneLevel/riskModuleIndex',
        '/finance/reimbursementIndex',
        '/fire/systemIndex',
        '/fire/reimbursementModuleIndex',
        '/fire/foodModuleIndex',
        '/fire/fixedAssetsIndex',
        '/fire/salaryModuleIndex',
        '/fire/authoritativeModuleIndex',
      ]
      if (arr.indexOf(url) > -1) {
        this.defaultOpendsList = [url, thirdUrl]
        return thirdUrl
      } else {
        this.defaultOpendsList = [url]
        return url
      }
    },

    reconstruction() {
      // 根据权限重铸导航栏
      for (let i = 0; i < this.menuList.length; i++) {
        if (this.menuList[i].keyword) {
          if (
            this.authorityList.indexOf(this.menuList[i].keyword) === -1
          ) {
            this.menuList.splice(i, 1);
            i = i - 1;
          } else {
            if (this.menuList[i].children.length > 0) {
              for (
                let j = 0;
                j < this.menuList[i].children.length;
                j++
              ) {
                if (
                  this.menuList[i].children[j].keyword &&
                  this.authorityList.indexOf(
                    this.menuList[i].children[j].keyword
                  ) === -1
                ) {
                  this.menuList[i].children.splice(j, 1);
                  j = j - 1;
                }
              }
            }
          }
        } else {
          if (this.menuList[i].children.length > 0) {
            for (
              let j = 0;
              j < this.menuList[i].children.length;
              j++
            ) {
              if (
                /* 暂时兼容（this.menuList[i].children[j].keyword &&） */
                 this.menuList[i].children[j].keyword &&
                this.authorityList.indexOf(
                  this.menuList[i].children[j].keyword
                ) === -1
              ) {
                this.menuList[i].children.splice(j, 1);
                j = j - 1;
              }
            }
            if (this.menuList[i].children.length === 0) {
              this.menuList.splice(i, 1);
              i = i - 1;
            }
          }
        }
      }
    },
  }
}
</script>

<style lang='scss'>
.menuDome {
  height: 100%;
  background-color: $bg-head;
  .el-menu {
    text-align: left;
    background-color: $bg-head;
    border: none;
  }
  .el-menu-item-group__title {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .el-menu-item,
  .el-submenu__title {
    height: 48px;
    line-height: 48px;
    padding: 0px 14px;
    padding-left: 14px !important;
    font-size: $fs-small-l;
    color: $color-LightGrey;
  }
  .el-menu-item-group {
    .el-menu-item {
      padding-left: 45px !important;
    }
    .el-menu-item.is-active {
      padding-left: 45px !important;
      color: $color-white;
      background: $bg-ReddishBlueActive;
    }
  }
  .el-menu-item:focus,
  .el-menu-item:hover,
  .el-submenu__title:hover{
    background: $bg-ReddishBlueActive;
    color: $color-white;
  }
  .img {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .svg-icon {
    margin-right: 10px;
    margin-bottom: 3px;
    vertical-align: middle;
  }
}
</style>